import { Component } from '@angular/core';

@Component({
  selector: 'eM-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'mark3';
}
